<template>
     <el-container>
        这是一张没画完的子查询页面
     </el-container>
</template>

<script>
export default {
  name: 'ContracrSubSearch',
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/subPage/ContractSubSearch.vue